/*
 * Wizard field action types
 */

export const CREATE_FIELD = 'CREATE_FIELD';
export const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateField = (id, value, valid) => ({
    type: UPDATE_FIELD,
    id,
    value,
    valid,
});

export const createField = (id, label, stepId) => ({
    type: CREATE_FIELD,
    id,
    label,
    stepId
});
